import  Home from './Home';
const __Home = Home;
export { __Home as Home };
export default Home;